const INFO = {
	main: {
		title: "JCCourt",
		name: "Jack C.",
		email: "jccourtenay@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/JCCourt/",
		linkedin: "https://www.linkedin.com/in/jack-courtenay/",
	},

	homepage: {
		title: "Back-end software developer and web3 enthusiast.",
		description:
			"I am a backend developer. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Jack C. I live in New Zealand, where I create solutions.",
		description:
			"I've worked on a few projects over the past few years at University and in my own time. My personal projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Price Tracker NZ",
			description:
				"A price tracker to search the cheapest options in NZ as well as Amazon AU.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/JCCourt/ChromePriceTrackerNZ",
		},

		{
			title: "TBA",
			description:
				"TBA.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
